import React from 'react';
import RightArrowIcon from '../icons/RightArrowIcon.jsx';

const ToggleArrow = ({ isExpanded }) => (
  <span
    className="collapse-caret"
    style={{
      display: 'inline-block',
      transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s ease',
    }}
  >
    <RightArrowIcon />
  </span>
);

export default ToggleArrow;
